// handle form tables, i.e. tables where every row is a form

// set the select-all checkbox to checked, unchecked, or inderterminate
function updateSelectAllState(list) {
  let selectAllCheckbox = list.find("input.select-all-checkbox");
  let options = list.find("input.option-checkbox");

  const id = (x) => x;
  let values = options.toArray().map((box) => box.checked);
  let checked = values.filter(id).length;
  let allChecked = values.length === checked;
  let atLeastOneChecked = checked > 0;

  selectAllCheckbox.prop("checked", allChecked);
  selectAllCheckbox.prop("indeterminate", !allChecked && atLeastOneChecked);
}

// handle any checkbox change
$(document).on("change", '.checkbox-list input[type="checkbox"]', (event) => {
  let checkbox = $(event.target);
  let list = checkbox.parents(".checkbox-list");
  let options = list.find("input.option-checkbox");

  if (checkbox.hasClass("select-all-checkbox")) {
    // toggle all options
    let state = checkbox.prop("checked");
    options.prop("checked", state);
  } else if (checkbox.hasClass("option-checkbox")) {
    // update the state of select-all checkbox
    updateSelectAllState(list);
  }
});

// set the select-all checkbox to the correct state on load
$(document).on("turbolinks:load", () => {
  $(".checkbox-list").each(function () {
    updateSelectAllState($(this));
  });
});
